import { ContattoDTO } from "./contatto-dto";
import { IndirizzoDTO } from "./indirizzo-dto";

export class AutoritaOrdinanteDTO {
	codiceFiscale: string;
	codiceProvincia: string;
	codiceTribunale: string;
	contatti: ContattoDTO;
	indirizzo: IndirizzoDTO;
	codiceRegione: string;
	idTribunale: string;
}